const locale = {
  'commodityList.message.enterOE': 'Please enter OE number',
  'commodityList.message.addSuccess': 'Added to cart successfully, you can go to the cart to view',
  'commodityList.message.fetchProductsSuccess': 'Batch query successful',
  'commodityList.message.placeholderOENumber': `Query up to 1000 OE numbers at once; separate multiple entries by lines，eg：
000001
000002
000003`,
  'commodityList.text.AllTotal': '{total} results have been found for you',
  'commodityList.text.groupTotal': 'found {total} results',
  'commodityList.button.search': 'Search',
  'commodityList.button.reset': 'Reset',
  'commodityList.title.accessoriesDetails': 'Parts detail',
  'commodityList.title.replacementNumber': 'Replacement number',
  'commodityList.title.storeName': 'Store',
  'commodityList.title.availabilityAndLeadTime': 'Availability & Lead Time',
  'commodityList.title.price': 'Price',
  'commodityList.title.operation': 'Operation',
  'commodityList.message.selectProduct': 'Please select products to add',
  'commodityList.text.selectedProducts': 'Selected {count} products (total {quantity} items), ',
  'commodityList.text.total': 'Total: ',
  'commodityList.button.batchAddToCart': 'Add to Cart',
  'commodityList.message.maxDataLimit':
    'Exceeding 2000 items, only the first 2000 will be searched',
  'commodityList.message.noImportData': 'No import data',
  'commodityList.message.batchQueryLoading': 'Batch querying...',
  'commodityList.message.noProductData': 'No product data',
  'commodityList.message.settleSuccess': 'Settlement saved successfully',
  'commodityList.message.orderFailed': 'Order failed, please try again later',
  'commodityList.button.orderNow': 'Order Now',
  'commodityList.import.oeNumber': 'Part Number', // 零件号
  'commodityList.import.brand': 'Parts Brand', // 配件品牌
  'commodityList.import.quantity': 'Quantity',
  'commodityList.import.rule1': '1. Only .xlsx files are supported.',
  'commodityList.import.rule2':
    '2. After uploading, you can batch add or update the list. The table below shows the importable fields, * means required.',
  'commodityList.button.batchImport': 'Batch Import',
  'commodityList.text.supportBatchQuery': 'Supports batch OE number query and auto-fill quantity',

  'commodityList.import.downloadTemplateUrl':
    'https://fe-static.cassmall.com/assets/applications/20250715163719/Import Template.xlsx',

  'commodityList.message.invalidData':
    'Some commodity quantities do not meet the requirements, please check',

  'commodity.multiple-sale.error.minSaleCount':
    'Purchase quantity cannot be less than the minimum sales quantity',
  'commodity.multiple-sale.error.multipleSaleCount':
    'Purchase quantity must be a multiple of the multiple sales quantity',

  total_match_found: '{total} match found',
  total_Item_selected: '{total} Item selected',
  Total_colon_total: 'Total: {total}',
  Request_a_quote: 'Request a quote',
  Coming_soon: 'Coming soon',
  Place_order: 'Place order',
  Specifications: 'Specifications',
  Pack_Size: 'Pack Size',
  total_pcs_case: '{total} pcs/case',
  MOQ: 'MOQ',
  total_pcs: '{total} pcs',
  In_stock: 'In stock',
  Backorder: 'Backorder',
  Immediate: 'Immediate',
  total_Found: '{total} Found',
  total_Unfound: '{total} Unfound',
  Availability_and_Lead_Time_Tip:
    'Lead time is the period from placing the order to when the goods are ready to be shipped.',
  Supported_Manufacturers: 'Supported Manufacturers',
};

export default locale;
